// How calendar appointment titles are rendered when not set manually.
// Mirrors decoda/enums/event_title_format.py. All presets except CUSTOM render
// dynamically from patient + service(s); CUSTOM keeps a manually-entered title.
export enum EventTitleFormat {
  PATIENT_SERVICES = "PATIENT_SERVICES", // "Jane Smith - Botox + Lip Filler" (default)
  SERVICES_PATIENT = "SERVICES_PATIENT", // "Botox + Lip Filler - Jane Smith"
  SERVICES_ONLY = "SERVICES_ONLY", // "Botox + Lip Filler"
  PATIENT_ONLY = "PATIENT_ONLY", // "Jane Smith"
  INITIALS_SERVICES = "INITIALS_SERVICES", // "JS - Botox + Lip Filler"
  FIRST_NAME_SERVICES = "FIRST_NAME_SERVICES", // "Jane - Botox + Lip Filler"
  // Preferred name in place of the legal first name, keeping the legal last
  // name. Falls back to the legal first name when there is no preferred name.
  PREFERRED_NAME_SERVICES = "PREFERRED_NAME_SERVICES", // "Janie Smith - Botox + Lip Filler"
  CUSTOM = "CUSTOM", // manual entry; uses the event title verbatim
}
